import moment from 'moment'
import type { IntlShape } from 'react-intl'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import { INTL_DAY_MONTH_NAME_SHORT, INTL_DMY_CASUAL_SHORT_FORMAT } from 'constants/dateFormats'
import { getChatActivityAge } from 'tripPlanner/utils/chatTimestamps'

export function getCompactRecentChatTimestampLabel(updatedAt: string, intl: IntlShape, now = moment()): string {
  const age = getChatActivityAge(updatedAt, now)
  switch (age.unit) {
    case 'minutes':
      return intl.formatMessage(
        {
          id: 'ypnHv6MlPJK7huj2MeOn',
          defaultMessage: '{count}m',
          description: 'Compact minutes-since label in the Trip Planner chat drawer, such as 1m or 34m',
        },
        { count: age.count },
      )
    case 'hours':
      return intl.formatMessage(
        {
          id: 'r3w7lFVyL-rGfdUBXZyf',
          defaultMessage: '{count}h',
          description: 'Compact hours-since label in the Trip Planner chat drawer, such as 1h or 7h',
        },
        { count: age.count },
      )
    case 'days':
      return intl.formatMessage(
        {
          id: 'UopsFCaBxwLeFeITP77a',
          defaultMessage: '{count}d',
          description: 'Compact days-since label in the Trip Planner chat drawer, such as 1d or 7d',
        },
        { count: age.count },
      )
    case 'date':
      return intlDateFormatter(updatedAt, age.sameYear ? INTL_DAY_MONTH_NAME_SHORT : INTL_DMY_CASUAL_SHORT_FORMAT, intl.locale)
    case 'invalid':
      return ''
  }
}
